import { getCountryName } from '../country/getCountryName';

export function formatAddress({
  country,
  city,
  zipCode,
  region,
  streetLine1,
  streetLine2,
  locale,
}: {
  country?: string | null;
  zipCode?: string | null;
  city?: string | null;
  region?: string | null;
  streetLine1?: string | null;
  streetLine2?: string | null;
  locale?: string;
}) {
  return [
    streetLine2,
    streetLine1,
    city,
    region,
    country ? getCountryName(country, { locale }) : null,
    zipCode,
  ]
    .filter(Boolean)
    .join(', ');
}
